export default __webpack_public_path__ + "static/media/Notes-table-view-icon.63145fc2.svg";